<main class="legal-page">
  <div class="top-row">
    <button type="button" class="back-btn" aria-label="Wstecz" (click)="goBack()">
      <sz-icon name="arrow-back" [size]="20" />
    </button>
    <sz-brand-block [compact]="true" />
  </div>

  <div class="legal-head">
    <div class="legal-head__kicker">Dokument</div>
    <h1 class="legal-head__title">Polityka <span class="legal-head__accent">prywatności.</span></h1>
  </div>

  <article class="legal-body">
    <h2>1. Administrator danych</h2>
    <p>
      <strong>DEV-TECH Infiniti Sp. z o.o.</strong><br />
      ul. Fryderyka Chopina 41/2<br />
      20-023 Lublin, Polska
    </p>
    <p>
      NIP: 7123461831<br />
      KRS: 0001059611<br />
      REGON: 526449543
    </p>
    <p>
      <a href="mailto:office@dev-infiniti.pl">office&#64;dev-infiniti.pl</a>
    </p>

    <h2>2. Jakie dane przetwarzamy</h2>
    <ul>
      <li>adres e-mail,</li>
      <li>dane profilu użytkownika,</li>
      <li>dane treningowe,</li>
      <li>dane techniczne urządzenia,</li>
      <li>adres IP,</li>
      <li>dane analityczne.</li>
    </ul>

    <h2>3. Cel przetwarzania danych</h2>
    <ul>
      <li>prowadzenie konta,</li>
      <li>synchronizacja treningów,</li>
      <li>poprawa działania aplikacji,</li>
      <li>obsługa zgłoszeń.</li>
    </ul>

    <h2>4. Podstawa prawna</h2>
    <ul>
      <li>art. 6 ust. 1 lit. b RODO,</li>
      <li>art. 6 ust. 1 lit. f RODO,</li>
      <li>art. 6 ust. 1 lit. a RODO.</li>
    </ul>

    <h2>5. Dostawcy usług</h2>
    <p>Możemy korzystać z:</p>
    <ul>
      <li>Firebase,</li>
      <li>Google Analytics,</li>
      <li>Apple App Store,</li>
      <li>Google Play,</li>
      <li>dostawców infrastruktury.</li>
    </ul>

    <h2>6. Prawa użytkownika</h2>
    <p>Użytkownik ma prawo do:</p>
    <ul>
      <li>dostępu do danych,</li>
      <li>sprostowania danych,</li>
      <li>usunięcia danych,</li>
      <li>ograniczenia przetwarzania,</li>
      <li>wniesienia sprzeciwu,</li>
      <li>wniesienia skargi do PUODO.</li>
    </ul>

    <h2>7. Kontakt</h2>
    <p>
      <a href="mailto:office@dev-infiniti.pl">office&#64;dev-infiniti.pl</a>
    </p>
  </article>
</main>
